import { XCircle } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import heroImage from "@/assets/business-closing.jpg";

const BusinessClosing = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Business Entity Dissolution Services</h2>
          <p className="text-lg text-muted-foreground">
            Proper dissolution and winding up of Texas business entities. We handle LLC and corporation closures, asset distribution, final tax returns, and state filings to avoid ongoing liability and compliance issues.
          </p>
        </div>
      </div>
    </section>
  );

  const aiKeyPoints = [
    "Complete LLC and corporation dissolution services in Texas",
    "Proper asset distribution and creditor notification",
    "Final tax return preparation and state filing",
    "Certificate of termination filing with Texas Secretary of State",
    "Avoid ongoing franchise tax liability and penalties",
    "Protection from personal liability during wind-down"
  ];

  const aiFaqs = [
    {
      question: "How long does it take to close a business in Texas?",
      answer: "The dissolution process typically takes 4-8 weeks, depending on whether there are outstanding debts, pending contracts, or complex asset distributions."
    },
    {
      question: "What happens if I don't properly dissolve my business?",
      answer: "You may continue to owe Texas franchise taxes, face penalties, and remain personally liable for ongoing obligations. The state may also administratively dissolve your entity, which can complicate future business ventures."
    },
    {
      question: "Can I dissolve a business that has debts?",
      answer: "Yes, but debts must be addressed properly. Creditors must be notified, and assets must be distributed according to Texas law priorities. We help navigate this process to minimize personal liability."
    }
  ];

  return (
    <GenericPracticePage 
      title="Closing of Business Entities" 
      subtitle="Properly Dissolve Your Business" 
      icon={<XCircle className="h-16 w-16 text-accent" />} 
      mainContent={mainContent} 
      heroImage={heroImage}
      category="business"
      aiKeyPoints={aiKeyPoints}
      aiFaqs={aiFaqs}
      aiServiceDescription="Professional business dissolution and entity closure services in Houston, Texas. We handle LLC and corporation wind-down, asset distribution, tax filings, and state termination to ensure proper compliance."
    />
  );
};
export default BusinessClosing;